module.exports = __webpack_public_path__ + "static/media/image-2.45308157.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/WebsiteVsSocialMediaPages/image-2.jpg
// module id = 419
// module chunks = 0